//const LITE_PMS = new Set(["hostfully"])


const isPmsLite = (pms: string) => false //LITE_PMS.has(pms)

export default isPmsLite